import { render } from "./LaboratoryPage.vue?vue&type=template&id=131e15c1"
import script from "./LaboratoryPage.vue?vue&type=script&lang=js"
export * from "./LaboratoryPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__